export const isOrgLayout = () => Boolean(/\/organisation/.test(window.location.href));
